import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-hidden"]


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomAttributeIcon',
  props: {
  decorative: {
    type: Boolean,
    default: false,
  },
  fillColor: {
    type: String,
    default: 'currentColor',
  },
  size: {
    type: Number,
    default: 24,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    "aria-hidden": __props.decorative,
    class: "material-design-icon sync-icon",
    role: "img"
  }, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      "enable-background": "new 0 0 24 24",
      height: "24",
      viewBox: "0 0 24 24",
      width: "24",
      class: "material-design-icon__svg"
    }, [
      _createElementVNode("g", null, [
        _createElementVNode("rect", {
          fill: "none",
          height: "24",
          width: "24"
        })
      ]),
      _createElementVNode("g", null, [
        _createElementVNode("g"),
        _createElementVNode("g", null, [
          _createElementVNode("path", { d: "M22,8l-4-4v3H3v2h15v3L22,8z" }),
          _createElementVNode("path", { d: "M2,16l4,4v-3h15v-2H6v-3L2,16z" })
        ])
      ])
    ], -1)
  ]))], 8, _hoisted_1))
}
}

})